import gql from 'graphql-tag'

export const MUTATION_UPDATE_SEGMENTS = gql`
  mutation RefreshSegments($segments_ids: [ID!]!) {
    refreshSegments(segments_ids: $segments_ids) {
      _id
      clients_qty
      clients_refreshed_at
    }
  }
`
export const QUERY_SEGMENTS_TAGS = gql`
  query SegmentsTags {
    segments(search: "", page: 1, pageSize: 1) {
      tags {
        name
        color
      }
    }
  }
`
